import moment from 'moment'

const mountDataFull = (dt, hour) => {
  const [hours, minutes] = hour.split(':')
  return moment(dt).hours(parseInt(hours, 10)).minutes(parseInt(minutes || 0, 10)).seconds(0).milliseconds(0)
}

// ============================================================================
// 1. BRANCH NORMALIZATION (idBranch)
// ============================================================================
const normalizeIdBranch = (idBranch, functionality) => {
  let processedIdBranch = idBranch || ''

  if (functionality === 'request.external') {
    if (processedIdBranch) {
      processedIdBranch = processedIdBranch.replace(/^0+/, '') || '0'
    }
    return processedIdBranch
  }

  if (functionality === 'datasheet.request') {
    if (processedIdBranch && !/^\d+$/.test(processedIdBranch)) {
      processedIdBranch = processedIdBranch.replace(/\D/g, '') || ''
    }
    return processedIdBranch
  }

  return processedIdBranch
}

// ============================================================================
// 2. PRODUCT/LM NORMALIZATION (listId)
// ============================================================================
const normalizeListId = (listId, functionality) => {
  let processedListId = listId || null

  if (functionality === 'datasheet.request') {
    if (processedListId) {
      processedListId = String(processedListId).trim()
    }
    return processedListId
  }

  const defaultNormalization = [
    'datasheet.preview.request',
    'pricebanner.preview.request',
    'pricebanner.request',
    'score.irc',
    'score.punctual',
    'score.stock.request',
    'score.stock.response'
  ]

  if (defaultNormalization.includes(functionality) || !functionality) {
    if (processedListId) {
      processedListId = String(processedListId).trim()
    }
    return processedListId
  }

  if (processedListId) {
    processedListId = String(processedListId).trim()
  }
  return processedListId
}

// ============================================================================
// 3. DATE NORMALIZATION (dtPeriod)
// ============================================================================
const normalizeDate = (dtPeriod, hrPeriod) => {
  const [dtStart, dtEnd] = dtPeriod || []
  const [hourStart, hourEnd] = hrPeriod || []

  const dataSt = dtStart
    ? mountDataFull(dtStart, hourStart || '00:00')
    : ''
  
  let dataEnd = dtEnd
    ? mountDataFull(dtEnd, hourEnd || '23:59')
    : ''
  
  if (dataEnd) {
    if (hourEnd) {
      dataEnd = dataEnd.seconds(59).milliseconds(999)
    } else {
      dataEnd = dataEnd.endOf('day')
    }
  }

  return {
    dtStart: dataSt ? dataSt.utc().format('YYYY-MM-DD HH:mm:ss') : '',
    dtEnd: dataEnd && hourEnd 
      ? dataEnd.utc().format('YYYY-MM-DD HH:mm:ss.SSS')
      : dataEnd 
        ? dataEnd.utc().format('YYYY-MM-DD HH:mm:ss')
        : ''
  }
}

// ============================================================================
// 4. TIME NORMALIZATION (hrPeriod)
// ============================================================================
const normalizeTime = (hrPeriod) => {
  const [hourStart, hourEnd] = hrPeriod || []
  return {
    hourStart: hourStart || '',
    hourEnd: hourEnd || ''
  }
}

export const normalizeFilterParams = (idBranch, functionality, listId) => ({
    idBranch: normalizeIdBranch(idBranch, functionality),
    listId: normalizeListId(listId, functionality)
  })

export const normalizeDateAndTime = (dtPeriod, hrPeriod) => ({
    ...normalizeDate(dtPeriod, hrPeriod),
    ...normalizeTime(hrPeriod)
  })

export const prepareParamsForBackend = (functionality, normalizedParams, dateTimeParams, page, size, direction = 'asc') => {
  const { idBranch: processedIdBranch, listId: processedListId } = normalizedParams
  const { dtStart, dtEnd, hourStart, hourEnd } = dateTimeParams

  const params = {
    functionality,
    dtStart,
    dtEnd,
    hourStart,
    hourEnd,
    page,
    size,
    direction
  }

  if (processedListId) {
    const numericListId = String(processedListId).trim()
    if (numericListId && !Number.isNaN(Number(numericListId)) && numericListId !== '') {
      params.listId = Number(numericListId)
    }
  }

  if (processedIdBranch && processedIdBranch.trim() !== '') {
    params.idBranch = processedIdBranch
  }

  return params
}
